import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { IShipping, TShippingName } from 'src/app/data/shipping/types';
import { getShippingDiscount } from 'src/app/services/discount.service/discount.functions';
import { FEToBEShipping } from 'src/app/functions';
import { DiscountService } from 'src/app/services/discount.service';

@Component({
  selector: 'app-form-shipping-method',
  templateUrl: './form-shipping-method.component.html',
  styleUrls: ['./form-shipping-method.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormShippingMethodComponent {
  @Input() disabledShippingNames!: TShippingName[];

  @Input() shippings!: IShipping[];

  @Input() set shipping(shipping: IShipping) {
    if (this._shipping !== shipping) {
      this._shipping = shipping;
      setTimeout(() => this.shippingChange.emit(shipping));
    }
  }

  get shipping(): IShipping {
    return this._shipping;
  }

  @Output() shippingChange = new EventEmitter<IShipping>();

  private _shipping?: IShipping;

  public readonly FEToBEShipping = FEToBEShipping;

  public readonly getShippingDiscount = getShippingDiscount;

  // as toggle-cards works with numbers
  // so we should have the index too
  private _i = 0; // default shipping

  set i(i: number) {
    if (i !== this._i) {
      this._i = i;
      this.shipping = this.shippings[i];
    }
  }

  get i(): number {
    return (
      this.shipping && this.shippings &&
      this.shippings.map(s => s.name).indexOf(this.shipping.name)
    );
  }

  constructor(
    public discountService: DiscountService,
  ) { }

  checkDisabled(shipping: IShipping): boolean {
    return this.disabledShippingNames.indexOf(shipping.name) > -1;
  }
}
